import React from "react";
import { Input } from "../../../../shared/ui/controls/Input/Input";
import { FieldWrapper } from "../../../../shared/ui";
import { FilterBar } from "../../../../shared/ui/layouts/FilterBar";
import {
  toAufgabenFiltersForm,
  useAufgabenFiltersParams,
} from "../../../../features/aufgaben";
import type { AufgabenFiltersForm } from "../../../../features/aufgaben";
import { aufgabenColumns } from "../model/constants";
import { TaskTypeSelect, TaskStatusSelect } from "../../../../entities/task";

export const AufgabenFilterBar: React.FC = () => {
  const [params, setParams] = useAufgabenFiltersParams();
  const filters = toAufgabenFiltersForm(params);

  const updateField = (field: keyof AufgabenFiltersForm, value: string) => {
    void setParams({ ...filters, [field]: value });
  };

  const handleSortChange = (sortKey: string, direction: string) => {
    void setParams({
      ...filters,
      sortField: sortKey as AufgabenFiltersForm["sortField"],
      sortDirection: direction as AufgabenFiltersForm["sortDirection"],
    });
  };

  return (
    <FilterBar columns={aufgabenColumns}>
      <FieldWrapper
        label="Title"
        sortKey="title"
        activeSortField={filters.sortField}
        sortOrder={filters.sortDirection}
        onSortChange={handleSortChange}
      >
        <Input
          as="input"
          value={filters.title}
          onChange={(value) => updateField("title", value)}
          placeholder=""
        />
      </FieldWrapper>
      <FieldWrapper
        label="Handwerker"
        sortKey="technicianName"
        activeSortField={filters.sortField}
        sortOrder={filters.sortDirection}
        onSortChange={handleSortChange}
      >
        <Input
          as="input"
          value={filters.technicianName}
          onChange={(value) => updateField("technicianName", value)}
          placeholder=""
        />
      </FieldWrapper>

      <FieldWrapper
        label="Aufgabenart"
        sortKey="taskType"
        activeSortField={filters.sortField}
        sortOrder={filters.sortDirection}
        onSortChange={handleSortChange}
      >
        <TaskTypeSelect
          value={filters.taskType}
          onChange={(value) => void setParams({ ...filters, taskType: value })}
          withAllOption
          className="!min-h-[40px] h-[40px]"
        />
      </FieldWrapper>

      <FieldWrapper label="Status">
        <TaskStatusSelect
          value={filters.status}
          onChange={(value) => void setParams({ ...filters, status: value })}
          withAllOption
          className="!min-h-[40px] h-[40px]"
        />
      </FieldWrapper>

      <FieldWrapper
        label="Datum"
        sortKey="plannedStart"
        activeSortField={filters.sortField}
        sortOrder={filters.sortDirection}
        onSortChange={handleSortChange}
      >
        <Input
          as="input"
          value={filters.plannedStart}
          onChange={(value) => updateField("plannedStart", value)}
          placeholder=""
          type="date"
        />
      </FieldWrapper>

      <FieldWrapper
        label="Abgabefrist"
        sortKey="deadline"
        activeSortField={filters.sortField}
        sortOrder={filters.sortDirection}
        onSortChange={handleSortChange}
      >
        <Input
          as="input"
          value={filters.deadline}
          onChange={(value) => updateField("deadline", value)}
          placeholder=""
          type="date"
        />
      </FieldWrapper>

      <FieldWrapper
        label="Soll"
        sortKey="plannedWorkDuration"
        activeSortField={filters.sortField}
        sortOrder={filters.sortDirection}
        onSortChange={handleSortChange}
      />

      <FieldWrapper label="Ist" />
    </FilterBar>
  );
};
